var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50065 2.5H17.5006C18.4211 2.5 19.1673 3.24619 19.1673 4.16667V15.8333C19.1673 16.7538 18.4211 17.5 17.5006 17.5H2.50065C1.58018 17.5 0.833984 16.7538 0.833984 15.8333V4.16667C0.833984 3.24619 1.58018 2.5 2.50065 2.5ZM2.50065 8.0151V15.8333H17.5007V8.01546L10.0006 11.7655L2.50065 8.0151ZM2.50065 6.15168L10.0007 9.90206L17.5007 6.15207V4.16667H2.50065V6.15168Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.e04ed31ff6df5aac824cdb78a94347a2.svg";
export { ForwardRef as ReactComponent };